import { createApi } from '@reduxjs/toolkit/query/react';

import baseLocalQuery from '@store/baseLocalQuery';

const localApi = createApi({
  baseQuery: baseLocalQuery,
  endpoints: () => ({}),
  reducerPath: 'localApi',
  tagTypes: [],
});

export default localApi;
